import "./TeamAndCareers.module.css";
import Header from "@/reusable_sections/Header";
import OurFoundersVision from "./sections/OurFoundersVision";
import OurApproachToCare from "./sections/OurApproachToCare";
import QuickApplication from "./sections/QuickApplication";
import Footer from "@/reusable_sections/Footer";
export default function TeamAndCareersPage() {
  return <div>
      <Header />
      <OurFoundersVision />
      <OurApproachToCare />
      <QuickApplication />
      <Footer />
    </div>;
}